import axios from "axios";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { MdOutlineAddCircleOutline } from "react-icons/md";
import { toast } from "react-toastify";

import { totalSalesExperience, totalSalesVolume, validationErrorMessage } from "../../../Utils/constants";
import { options } from "../../../Utils/constants";
import { CustomDropdown } from "../../../Utils/dropdown";
import {
  getLocalStorage,
  updateTiersData,
  verifyTiers2Completion,
  verifyTiers3Completion,
} from "../../../Utils/localStorage";

const Tier3 = (props) => {
  const formRef = useRef(null);
  const [salesPlatform, setSalesPlatform] = useState([]);
  const [expectations, setExpectations] = useState([]);
  const [platforms1, setPlatforms1] = useState([]);
  const [platforms2, setPlatforms2] = useState([]);
  const [showTier, setShowTier] = useState(false);

  const [validation, setValidation] = useState({
    expectations: {
      error: false
    },
    totalSalesExperience: {
      error: false
    },
    totalSalesVolume: {
      error: false
    },
    sales_experience_description: {
      error: false
    },
    platforms1: {
      error: false
    },
    platforms2: {
      error: false
    }
  });

  const CreateElements = (props) => {
    return React.createElement(
      "div",
      { className: "row mb-3 mt-lg-0 mt-5" },

      React.createElement(
        "div",
        { className: "col-lg-3 mb-lg-0 mb-3" },
        React.createElement("label", { className: "d-lg-none d-block" }, "Sales platform"),
        React.createElement("input", {
          type: "text",
          id: `platformSales${
            props?.index ? props?.index : salesPlatform.length === 0 ? 2 : salesPlatform.length + 2
          }`,
          name: `platformSales${
            props?.index ? props?.index : salesPlatform.length === 0 ? 2 : salesPlatform.length + 2
          }`,
          defaultValue: props?.name ? props?.name : ""
        })
      ),

      React.createElement(
        "div",
        { className: "col-lg-3 mb-lg-0 mb-3" },
        React.createElement("label", { className: "d-lg-none d-block" }, "Years in platform"),
        React.createElement("input", {
          type: "number",
          id: `platformYears${
            props?.index ? props?.index : salesPlatform.length === 0 ? 2 : salesPlatform.length + 2
          }`,
          name: `platformYears${
            props?.index ? props?.index : salesPlatform.length === 0 ? 2 : salesPlatform.length + 2
          }`,
          defaultValue: props?.years ? props?.years : 0,
          min: 0,
          step: 1,
          max: 50
        })
      ),

      React.createElement(
        "div",
        { className: "col-lg-3 mb-lg-0 mb-3" },
        React.createElement("label", { className: "d-lg-none d-block" }, "Sales volume (USD)"),
        React.createElement("input", {
          type: "number",
          id: `platformSalesVolume${
            props?.index ? props?.index : salesPlatform.length === 0 ? 2 : salesPlatform.length + 2
          }`,
          name: `platformSalesVolume${
            props?.index ? props?.index : salesPlatform.length === 0 ? 2 : salesPlatform.length + 2
          }`,
          min: 0,
          step: 1,
          max: 1000000,
          defaultValue: props?.volume ? props?.volume : 0
        })
      ),

      React.createElement(
        "div",
        { className: "col-lg-3 mb-lg-0 mb-3" },
        React.createElement("label", { className: "d-lg-none d-block" }, "Team members"),
        React.createElement("input", {
          type: "number",
          id: `platformMembers${
            props?.index ? props?.index : salesPlatform.length === 0 ? 2 : salesPlatform.length + 2
          }`,
          name: `platformMembers${
            props?.index ? props?.index : salesPlatform.length === 0 ? 2 : salesPlatform.length + 2
          }`,
          min: 0,
          step: 1,
          max: 1000,
          defaultValue: props?.members ? props?.members : 0
        })
      )
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData(formRef.current);
    const formData = Object.fromEntries(data);

    let error = false;
    setValidation({
      expectations: {
        error: false
      },
      totalSalesExperience: {
        error: false
      },
      totalSalesVolume: {
        error: false
      },
      sales_experience_description: {
        error: false
      },
      platforms1: {
        error: false
      },
      platforms2: {
        error: false
      }
    });

    if (!getLocalStorage("t2")) {
      toast.error("You must complete About you form.", {
        toastId: "t2NotReady",
        hideProgressBar: true,
        style: options.dropdownStyle
      });
      error = true;
    }
    if (
      formData.expectation1 === undefined &&
      formData.expectation2 === undefined &&
      formData.expectation3 === undefined
    ) {
      setValidation((prevState) => ({
        ...prevState,
        expectations: {
          error: true
        }
      }));
      error = true;
    }

    if (formData.sales_experience_description === "") {
      setValidation((prevState) => ({
        ...prevState,
        sales_experience_description: {
          error: true
        }
      }));
      error = true;
    }

    if (formData.totalSalesExperience === "" || +formData.totalSalesExperience === 0) {
      setValidation((prevState) => ({
        ...prevState,
        totalSalesExperience: {
          error: true
        }
      }));
      error = true;
    }

    if (formData.totalSalesVolume === "" || +formData.totalSalesVolume === 0) {
      setValidation((prevState) => ({
        ...prevState,
        totalSalesVolume: {
          error: true
        }
      }));
      error = true;
    }

    if (formData.platformSales1 === "") {
      setValidation((prevState) => ({
        ...prevState,
        platforms1: {
          error: true
        }
      }));
      error = true;
    }
    if (formData.platformSales2 === "") {
      toast.error("You need to add Sales platform", {
        toastId: "platformsales2",
        hideProgressBar: true,
        style: options.dropdownStyle
      });
      error = true;
    }
    if (formData.platformSales3 === "") {
      toast.error("You need to add Sales platform", {
        toastId: "platformsales3",
        hideProgressBar: true,
        style: options.dropdownStyle
      });
      error = true;
    }

    if (!verifyTiers2Completion()) {
      error = true;
      toast.error("You must complete About you form", {
        toastId: "noTier2",
        hideProgressBar: true,
        style: options.dropdownStyle
      });
    }

    if (!error) {
      // Send info to server
      if (e.currentTarget.className.includes("submit-now")) {
        props?.openModal();
      }

      localStorage.setItem("tier3", true);

      if (!e.currentTarget.className.includes("submit-now")) {
        toast.success("You have updated your information.", {
          toastId: "updated1",
          hideProgressBar: true,
          style: options.dropdownStyle
        });
      }

      localStorage.setItem(
        "t3",
        JSON.stringify({
          sales_experience_years: formData.totalSalesExperience,
          sales_experience_volumes: formData.totalSalesVolume,
          sales_experience_description: formData.sales_experience_description,
          expectations: expectations,
          platforms1: {
            name: formData.platformSales1,
            years: +formData.platformYears1,
            volume: formData.platformSalesVolume1,
            members: formData.platformMembers1
          },
          platforms2: {
            name: formData.platformSales2,
            years: +formData.platformYears2,
            volume: formData.platformSalesVolume2,
            members: formData.platformMembers2
          },
          platforms3: {
            name: formData.platformSales3,
            years: +formData.platformYears3,
            volume: formData.platformSalesVolume3,
            members: formData.platformMembers3
          }
        })
      );
    }
  };

  useEffect(() => {
    if (getLocalStorage("t3")?.expectations) {
      setExpectations(getLocalStorage("t3")?.expectations);
    }
  }, []);

  useEffect(() => {
    if (getLocalStorage("t3")?.platforms2 && getLocalStorage("t3")?.platforms2?.name) {
      setSalesPlatform((prevState) => [
        ...prevState,
        salesPlatform.concat(
          <CreateElements
            name={getLocalStorage("t3")?.platforms2?.name}
            years={getLocalStorage("t3")?.platforms2?.years}
            volume={getLocalStorage("t3")?.platforms2?.volume}
            members={getLocalStorage("t3")?.platforms2?.members}
            index={2}
            key={2}
          />
        )
      ]);
    }
    if (getLocalStorage("t3")?.platforms3 && getLocalStorage("t3")?.platforms3?.name) {
      setSalesPlatform((prevState) => [
        ...prevState,
        salesPlatform.concat(
          <CreateElements
            name={getLocalStorage("t3")?.platforms3?.name}
            years={getLocalStorage("t3")?.platforms3?.years}
            volume={getLocalStorage("t3")?.platforms3?.volume}
            members={getLocalStorage("t3")?.platforms3?.members}
            index={3}
            key={3}
          />
        )
      ]);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("tier2")) setShowTier(true);
  }, [props?.refetch]);

  return (
    <form autoComplete="off" ref={formRef} className="row">
      <div className="form-wrapper p-sm-5 p-4">
        <div className="row mb-4">
          <div className="col-12">
            <h1 className="font-pnsb mb-0 tier3">Experience</h1>
            <small className="font-pnsb mb-4 tier2 text-light">
              {showTier ? "Fields marked with * are mandatory" : "You need to complete About you"}
            </small>
          </div>
        </div>
        {showTier ? (
          <>
            <div className="row mb-4">
              <div className="col-12">
                <label
                  htmlFor="totalSalesExperience"
                  className={validation.totalSalesExperience.error ? "mb-0" : null}>
                  Total sales experience in all platforms *
                </label>
                {validationErrorMessage(validation.totalSalesExperience.error)}
                <div className="position-relative inside-placeholder">
                  <span className="text-light">
                    <small>YEARS</small>
                  </span>
                  <input
                    type="number"
                    min={1}
                    max={100}
                    id="totalSalesExperience"
                    name="totalSalesExperience"
                    className={validation.totalSalesExperience.error ? "error" : null}
                    defaultValue={
                      getLocalStorage("t3")?.sales_experience_years
                        ? getLocalStorage("t3")?.sales_experience_years
                        : 0
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-12">
                <label
                  htmlFor="totalSalesVolume"
                  className={validation.totalSalesVolume.error ? "mb-0" : null}>
                  Total sales volume in all platforms *
                </label>
                {validationErrorMessage(validation.totalSalesVolume.error)}
                <div className="position-relative inside-placeholder">
                  <span className="text-light">
                    <small>$</small>
                  </span>
                  <input
                    type="number"
                    min={0}
                    step={1}
                    max={1000000}
                    id="totalSalesVolume"
                    name="totalSalesVolume"
                    className={validation.totalSalesVolume.error ? "error" : null}
                    defaultValue={
                      getLocalStorage("t3")?.sales_experience_volumes
                        ? getLocalStorage("t3")?.sales_experience_volumes
                        : 0
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-12">
                <label
                  htmlFor="salesExperience"
                  className={validation.sales_experience_description.error ? "mb-0" : null}>
                  Describe your sales experience *
                </label>
                {validationErrorMessage(validation.sales_experience_description.error)}
                <textarea
                  name="sales_experience_description"
                  id="sales_experience_description"
                  className={validation.sales_experience_description.error ? "error" : null}
                  defaultValue={
                    getLocalStorage("t3")?.sales_experience_description
                      ? getLocalStorage("t3")?.sales_experience_description
                      : ""
                  }
                  placeholder="I've been working ..."></textarea>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-12">
                <div className="social-media-list">
                  <div className="row mb-3">
                    <div className="col-lg-3 mb-lg-0 mb-3">
                      <label
                        htmlFor="platformSales1"
                        className={validation.platforms1.error ? "mb-0" : null}>
                        Sales platform
                      </label>
                      {validationErrorMessage(validation.platforms1.error)}
                      <input
                        type="text"
                        id="platformSales1"
                        name="platformSales1"
                        defaultValue={
                          getLocalStorage("t3")?.platforms1 &&
                          getLocalStorage("t3")?.platforms1?.name
                            ? getLocalStorage("t3")?.platforms1?.name
                            : ""
                        }
                      />
                    </div>
                    <div className="col-lg-3 mb-lg-0 mb-3">
                      <label
                        htmlFor="platformYears1"
                        className={validation.platforms1.error ? "mb-0" : null}>
                        Years in platform
                      </label>
                      {validationErrorMessage(validation.platforms1.error)}

                      <input
                        type="number"
                        min={0}
                        step={1}
                        max={50}
                        id="platformYears1"
                        name="platformYears1"
                        defaultValue={
                          getLocalStorage("t3")?.platforms1 &&
                          getLocalStorage("t3")?.platforms1?.years
                            ? getLocalStorage("t3")?.platforms1?.years
                            : 0
                        }
                      />
                    </div>
                    <div className="col-lg-3 mb-lg-0 mb-3">
                      <label
                        htmlFor="platformSalesVolume1"
                        className={validation.platforms1.error ? "mb-0" : null}>
                        Sales volume (USD)
                      </label>
                      {validationErrorMessage(validation.platforms1.error)}

                      <input
                        type="number"
                        min={0}
                        step={1}
                        max={1000}
                        id="platformSalesVolume1"
                        name="platformSalesVolume1"
                        defaultValue={
                          getLocalStorage("t3")?.platforms1 &&
                          getLocalStorage("t3")?.platforms1?.volume
                            ? getLocalStorage("t3")?.platforms1?.volume
                            : 0
                        }
                      />
                    </div>
                    <div className="col-lg-3 mb-lg-0 mb-3">
                      <label
                        htmlFor="platformMembers1"
                        className={validation.platforms1.error ? "mb-0" : null}>
                        Team members
                      </label>
                      {validationErrorMessage(validation.platforms1.error)}
                      <input
                        type="number"
                        min={0}
                        step={1}
                        max={1000}
                        id="platformMembers1"
                        name="platformMembers1"
                        defaultValue={
                          getLocalStorage("t3")?.platforms1 &&
                          getLocalStorage("t3")?.platforms1?.members
                            ? getLocalStorage("t3")?.platforms1?.members
                            : 0
                        }
                      />
                    </div>
                  </div>

                  {salesPlatform}
                </div>
                {salesPlatform.length < 2 ? (
                  <button
                    className="gradient rounded-5 alt"
                    onClick={(e) => {
                      e.preventDefault();

                      setSalesPlatform(
                        salesPlatform.concat(<CreateElements key={salesPlatform.length} />)
                      );
                    }}>
                    <span className="rounded-5 d-flex gap-2">
                      <MdOutlineAddCircleOutline color="#fff" fontSize="24px" />
                      Add platform
                    </span>
                  </button>
                ) : null}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <label className={validation.expectations.error ? "mb-0" : null}>
                  Expectations *
                </label>
                {validationErrorMessage(
                  validation.expectations.error,
                  "You must choose at least one option!"
                )}
                <div className="d-lg-flex">
                  <label className="checkbox me-5 d-lg-inline-block d-block" htmlFor="expectation1">
                    <input
                      type="checkbox"
                      id="expectation1"
                      name="expectation1"
                      value="Extra income"
                      defaultChecked={
                        getLocalStorage("t3") &&
                        getLocalStorage("t3")?.expectations.includes("Extra income")
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        if (!e.target.checked) {
                          setExpectations(
                            expectations.filter((expectation) => expectation !== e.target.value)
                          );
                        } else {
                          setExpectations((prevState) => [...prevState, e.target.value]);
                        }
                      }}
                    />
                    <span className="text-light">Extra income</span>
                  </label>
                  <label className="checkbox me-5 d-lg-inline-block d-block" htmlFor="expectation2">
                    <input
                      type="checkbox"
                      id="expectation2"
                      name="expectation2"
                      value="Professional advancement"
                      defaultChecked={
                        getLocalStorage("t3") &&
                        getLocalStorage("t3")?.expectations.includes("Professional advancement")
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        if (!e.target.checked) {
                          setExpectations(
                            expectations.filter((expectation) => expectation !== e.target.value)
                          );
                        } else {
                          setExpectations((prevState) => [...prevState, e.target.value]);
                        }
                      }}
                    />
                    <span className="text-light">Professional advancement</span>
                  </label>
                  <label className="checkbox d-lg-inline-block d-block" htmlFor="expectation3">
                    <input
                      type="checkbox"
                      id="expectation3"
                      name="expectation3"
                      value="Performance"
                      defaultChecked={
                        getLocalStorage("t3") &&
                        getLocalStorage("t3")?.expectations.includes("Performance")
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        if (!e.target.checked) {
                          setExpectations(
                            expectations.filter((expectation) => expectation !== e.target.value)
                          );
                        } else {
                          setExpectations((prevState) => [...prevState, e.target.value]);
                        }
                      }}
                    />
                    <span className="text-light">Performance</span>
                  </label>
                </div>
              </div>
            </div>
            {/* <div className="row mt-4">
              <div className="col-12 text-md-end">
                <button
                  className="gradient alt d-inline-block save-form"
                  onClick={(e) => handleSubmit(e)}>
                  <span>Save form</span>
                </button>
              </div>
            </div> */}
          </>
        ) : null}
      </div>

      {showTier ? (
        <div className="d-flex align-items-center mt-4 justify-content-center">
          <button
            disabled={getLocalStorage("tier2") !== null ? false : true}
            className="gradient fill large-width large-height ms-md-3 submit-now"
            onClick={(e) => handleSubmit(e)}>
            <span>Submit form now</span>
          </button>
        </div>
      ) : null}
    </form>
  );
};

export default Tier3;
